<mat-expansion-panel #panel="matExpansionPanel" [attr.data-section]="section" [expanded]="expanded">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <span class="modify-session-section__title">
        {{ translationKey | translate }}
      </span>
    </mat-panel-title>
    <mat-panel-description class="modify-session-section__action">
      <!-- Header actions only make sense once the section is open. -->
      @if (panel.expanded) {
        <ng-content select="[modifySessionSectionAction]"></ng-content>
      }
    </mat-panel-description>
  </mat-expansion-panel-header>
  <ng-content></ng-content>
</mat-expansion-panel>
